// libs
import React, { MouseEvent, useRef } from 'react'
import { Grid, Box, ButtonBase } from '@material-ui/core'

// assets
import * as S from './styles'
import { ReactComponent as FileIcon } from 'presentation/assets/icons/FileGreenIcon.svg'
import { ReactComponent as DownloadIcon } from 'presentation/assets/icons/DonwloadIcon.svg'

interface UploadFileProps {
  onFileUpload?: (evt: File) => void
  sectionId: string
}

function UploadFile({ onFileUpload, sectionId }: UploadFileProps) {
  const labelRef = useRef<HTMLLabelElement | null>(null)

  const handleUploadClick = (e: MouseEvent<any>) => {
    e.stopPropagation()
    if (labelRef.current) labelRef.current.click()
  }

  const handleUploadChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (evt.target.files) {
      const files = evt.target.files

      if (files[0]) {
        const file = files[0]
        if (onFileUpload) onFileUpload(file)
      }
    }
  }

  const inputId = `UploadFile-uploadInput-${sectionId}`

  return (
    <Box bgcolor="white" borderRadius="10px" p={2} height="150px">
      <input
        type="file"
        value=""
        style={nonDisplay}
        id={inputId}
        accept={
          'image/jpeg,image/gif,image/png,image/bmp,image/tif,image/tiff,application/pdf,image/x-eps,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet'
        }
        onChange={handleUploadChange}
      />
      <label style={nonDisplay} htmlFor={inputId} ref={labelRef} />
      <Grid
        container
        spacing={1}
        onClick={handleUploadClick}
        alignItems="stretch"
        style={{ height: '100%' }}
      >
        <Grid item xs={12}>
          <Box
            width="100%"
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Box width="100%" display="flex" alignItems="center">
              <Box
                mr={1}
                p={1}
                bgcolor="#F0F6EF"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="8px"
              >
                <FileIcon />
              </Box>
              <S.SectionTitle>Fazer upload do arquivo</S.SectionTitle>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box width="100%" height="100%" display="flex" alignItems="flex-end">
            <ButtonBase onClick={handleUploadClick}>
              <Box display="flex" alignItems="center">
                <Box mr={0.5}>
                  <DownloadIcon />
                </Box>
                <S.UploadText>Upload</S.UploadText>
              </Box>
            </ButtonBase>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export { UploadFile }

const nonDisplay = { display: 'none' }
